module.exports = __webpack_public_path__ + "static/media/icon-send-link.8b299091.svg";